import React, { useEffect } from "react";
import Button, { ButtonColorTypes } from "../shared-components/Button";
import TrashOutlineIcon from "../shared-components/icons/TrashOutlineIcon";
import { useRemoveRatingAndKeywordsPostsItem } from "../api/ItemsApi";
import { AffiliationItemWithMetaData } from "../api/Items";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { useReportTimer } from "../reports/ReportDetailProvider";
import {
  ConfirmDialogActions,
  useConfirmationDialog,
} from "../shared-components/ConfirmationDialog";

type Props = {
  handleAction: (action: "remove" | "cancel" | "completed") => void;
  item: AffiliationItemWithMetaData;
};

const ButtonAffiliationRemove = ({ handleAction, item }: Props) => {
  const { resetTimer } = useReportTimer();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { modal, show, hide } = useConfirmationDialog();

  function performAction() {
    setIsLoading(true);
    setTimeout(() => {
      handleAction("remove");
    }, 333);
  }

  const { mutateAsync: removeItem, isSuccess } =
    useRemoveRatingAndKeywordsPostsItem();

  function handleRemove() {
    show(
      "",
      "Are you sure you want to remove the affiliation?",
      (action: ConfirmDialogActions) => {
        if (action === "continue") {
          removeItem({
            item_uuids: [item.item.external_id],
          }).then(() => {
            resetTimer?.();
            hide();
            performAction();
          });
        }
      }
    );
  }

  useEffect(() => {
    if (isSuccess) {
      handleAction("completed");
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      <div className="hover:bg-slate-200 rounded-md">
        <Button
          text={
            <div className="flex gap-3 items-center px-2 py-0.5 text-gray-500">
              <TrashOutlineIcon />
              <span className="text-gray-700 text-xs font-light">Remove</span>
            </div>
          }
          colorType={ButtonColorTypes.custom}
          onClick={handleRemove}
        />
      </div>
      {modal}
    </>
  );
};

export default ButtonAffiliationRemove;
